/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementReadEventCsvResponse } from './EventManagementReadEventCsvResponse';

export type EventManagementReadEventCsvResponseApiRespoonse = {
    data?: EventManagementReadEventCsvResponse;
    status?: EventManagementReadEventCsvResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementReadEventCsvResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

